import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
// import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function PrivacyPolicy() {
  const [formData, setFormData] = useState({
    content: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);
  //   const navigate = useNavigate(null);

  const handleInputChange = (val) => {
    setFormData({ ...formData, content: val });
  };

  useEffect(()=>{
    getContent();
  },[])

  const getContent = async () => {
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/terms-conditions/get-terms?type=privacy-policy`,
        {
          headers: headers,
        }
      );

      if (response.data.statusCode === 200) {
        setFormData({
            content: response.data.result.content,
         })
      }else{
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setDisableBtn(true);

      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/terms-conditions/create-terms`,
        { content: formData.content, type: "privacy-policy" },
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        toast.success("Privacy Policy successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableBtn(false);
  };

  return (
    <Layout>
      <div>
        {/* Privacy Policy */}
        <ToastContainer />
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">Privacy Policy</h2>
          </div>
          <div className="w-full mt-10">
            <form action="" className="w-full" onSubmit={handleSubmit}>
              <div>
                <h2 className="mb-2">Write Below</h2>
                <ReactQuill
                  theme="snow"
                  value={formData.content}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  className="rounded-md h-[46px] w-full bg-[#2c2c38] text-white hover:bg-[#191919]"
                  disabled={disableBtn}
                >
                  {disableBtn ? "Please Wait ..." : "Save"}
                </button>
              </div>
              <div className="mt-16">
                <h3 className="">Preview:</h3>
                <div dangerouslySetInnerHTML={{ __html: formData.content }} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}
